document.addEventListener('DOMContentLoaded', function() {
    const crabArea = document.querySelector('.Crab_Area');
    const crab = document.querySelector('.Crab_Area .Crab');

    if(crabArea === null || crab === null) {
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if(!crab.classList.contains('Crab_Shown')) {
                    crab.classList.add('Crab_Walk');
                    crab.classList.add('Crab_Shown');
                    setTimeout(() => {
                        window.addEventListener('mousemove', trackCrab);
                        isRunning = true;
                    }, 2400);
                } else {
                    window.addEventListener('mousemove', trackCrab);
                    isRunning = true;
                }
            } else {
                window.removeEventListener('mousemove', trackCrab);
                isRunning = false;
            }
        });
    }, {
        threshold: 0.1 // Adjust this value as needed
    });

    observer.observe(crabArea);

    // Cheat to smoothen out -180 to 180 transition
    let weirdIncrement = 0;
    let lastAngle = null;

    function getRealAngle(angle) {
        return angle + weirdIncrement * 360 + 90;
    }

    function getDistance(x1, y1, x2, y2) {
        // (diminish total distance as it gets bigger)
        return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)); 
    }

    function easeOutSine(x) {
        return Math.sin((x * Math.PI) / 2);
    }

    let movement, angleDeg;
    const biggestDistance = Math.sqrt(window.innerWidth**2 + window.innerHeight**2);
    const biggestMovement = -10;  // Biggest value of distance is display width

    function trackCrab(event) {
        if(crab === null) {
            return;
        }

        const crabAreaRect = crabArea.getBoundingClientRect();
        const crabAreaX = (crabAreaRect.left + crabAreaRect.right) / 2;
        const crabAreaY = (crabAreaRect.top + crabAreaRect.bottom) / 2;

        // Get distance between crab and mouse
        movement = getDistance(crabAreaX, crabAreaY, event.clientX, event.clientY);
        movement = Math.max(easeOutSine(movement/biggestDistance) * biggestMovement, biggestMovement);

        const crabRect = crab.getBoundingClientRect();
        const crabX = (crabRect.left + crabRect.right) / 2;
        const crabY = (crabRect.top + crabRect.bottom) / 2;

        const angle = Math.atan2(event.clientY - crabY, event.clientX - crabX);
        angleDeg = angle * 180 / Math.PI;

        //Literally separating the conditions to make it easier to read
        const signCheck = Math.sign(lastAngle) != Math.sign(angleDeg); // Check for jumps
        const angleCheck = Math.abs(angleDeg) > 90; // Makes sure we look for 180 to -180 jumps

        if(lastAngle != null && signCheck && angleCheck && lastAngle > angleDeg) {
            weirdIncrement ++;
        }
        else if(lastAngle != null && signCheck && angleCheck && lastAngle < angleDeg) {
            weirdIncrement --;
        }

        lastAngle = angleDeg;
    }

    let isRunning = false;
    const easing = 0.008;

    function animationLoop() {
        if(!isRunning) {
            requestAnimationFrame(animationLoop);
            return;
        }

        // Get crab properties --y and --rotate
        const currentY = parseFloat(crab.style.getPropertyValue('--y')) || 0;
        const currentRotate = parseFloat(crab.style.getPropertyValue('--rotate')) || 24;

        // Calculate new values with easing
        const newY = currentY + (movement - currentY) * easing;
        const newRotate = currentRotate + (getRealAngle(angleDeg) - currentRotate) * easing;

        // Set properties back to the crab
        crab.style.setProperty('--y', (newY ? newY + 'rem' : '0rem'));
        crab.style.setProperty('--rotate', (newRotate ? newRotate + 'deg' : '24deg'));

        requestAnimationFrame(animationLoop);
    }

    requestAnimationFrame(animationLoop);
});

